import {Box} from '@material-ui/core'
import ButtonLarge from 'src/components/Buttons/ButtonLarge'
import Styled from 'src/components/Styled'
import styles from './styles'

export const FormContainer = Styled(Box, styles.formContainer)
export const ButtonsBox = Styled(Box, styles.buttonsBox)
export const ButtonSave = Styled(ButtonLarge, styles.buttonSave)
export const ButtonCancel = Styled(ButtonLarge, styles.buttonCancel)
